import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo
} from 'react'

const COUNTDOWN = 10

const INIT_GET_NEXT = {
  counter: parseInt(localStorage.getItem('getNextCounter'), 10) || null
}

export const GetNextContext = createContext(INIT_GET_NEXT)

export const GetNextProvider = ({ children }) => {
  const { counter: init } = useContext(GetNextContext)
  const [counter, setCounter] = useState(init)

  const startCount = () => {
    setCounter(COUNTDOWN)
    localStorage.setItem('getNextCounter', COUNTDOWN)
  }

  useEffect(() => {
    if (counter > 0) {
      localStorage.setItem('getNextCounter', counter - 1)
      setTimeout(() => setCounter(counter - 1), 1000)
    }
  }, [counter])

  const value = useMemo(() => [counter, startCount], [counter, startCount])

  return (
    <GetNextContext.Provider value={value}>{children}</GetNextContext.Provider>
  )
}
